import { faAlgolia } from '@fortawesome/free-brands-svg-icons';
import { faChrome } from '@fortawesome/free-brands-svg-icons/faChrome';
import { faEdge } from '@fortawesome/free-brands-svg-icons/faEdge';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons/faFacebookMessenger';
import { faFirefox } from '@fortawesome/free-brands-svg-icons/faFirefox';
import { faFontAwesomeAlt } from '@fortawesome/free-brands-svg-icons/faFontAwesomeAlt';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faSafari } from '@fortawesome/free-brands-svg-icons/faSafari';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faBookmark } from '@fortawesome/free-regular-svg-icons/faBookmark';
import { faFlag } from '@fortawesome/free-regular-svg-icons/faFlag';
import { faStar } from '@fortawesome/free-regular-svg-icons/faStar';
import { faGlassCheers, faWineBottle } from '@fortawesome/free-solid-svg-icons';
import { faAnchor } from '@fortawesome/free-solid-svg-icons/faAnchor';
import { faBlender } from '@fortawesome/free-solid-svg-icons/faBlender';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
import { faDesktop } from '@fortawesome/free-solid-svg-icons/faDesktop';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons/faExternalLink';
import { faFeatherAlt } from '@fortawesome/free-solid-svg-icons/faFeatherAlt';
import { faFrog } from '@fortawesome/free-solid-svg-icons/faFrog';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faHandPointUp } from '@fortawesome/free-solid-svg-icons/faHandPointUp';
import { faInfinity } from '@fortawesome/free-solid-svg-icons/faInfinity';
import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage';
import { faMobile } from '@fortawesome/free-solid-svg-icons/faMobile';
import { faSearchMinus } from '@fortawesome/free-solid-svg-icons/faSearchMinus';
import { faSearchPlus } from '@fortawesome/free-solid-svg-icons/faSearchPlus';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import { faShuffle } from '@fortawesome/free-solid-svg-icons/faShuffle';
import { faStethoscope } from '@fortawesome/free-solid-svg-icons/faStethoscope';
import { faTheaterMasks } from '@fortawesome/free-solid-svg-icons/faTheaterMasks';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons/faUserSecret';
import {
  albums,
  book,
  bookmarks,
  closeOutline,
  cloudOfflineOutline,
  disc,
  help,
  image,
  logoPwa,
  musicalNotesSharp,
  pushSharp,
  star,
} from 'ionicons/icons';

import { faBoobs, faPenis } from './icons';

export const fontAwesomeIcons = [
  faBoobs,
  faPenis,
  faAlgolia,
  faShuffle,
  faShareAlt,
  faSearchMinus,
  faSearchPlus,
  faBookmark,
  faStar,
  faBlender,
  faFeatherAlt,
  faTheaterMasks,
  faAnchor,
  faStethoscope,
  faLanguage,
  faUserSecret,
  faGlassCheers,
  faInfinity,
  faFlag,
  faGraduationCap,
  faWineBottle,
  faFrog,
  faHandPointUp,
  faExternalLink,
  faFontAwesomeAlt,
  faChrome,
  faSafari,
  faFirefox,
  faEdge,
  faMobile,
  faDesktop,
  faFacebookMessenger,
  faInstagram,
  faWhatsapp,
  faEnvelope,
  faCommentDots,
];

export const ionicIcons = {
  closeOutline,
  musicalNotesSharp,
  albums,
  book,
  disc,
  star,
  bookmarks,
  logoPwa,
  pushSharp,
  help,
  cloudOfflineOutline,
  image,
};
